define('app/models/Domain',['require','glu/model','glu/util','config','./Field','glu/collection','glu/log','app/models/Report','app/models/Monitor','app/models/CompoundFilter','app/models/FieldFilter','app/config/filterTypes','app/config/reportTypes','./Column','glu/appBus','app/app'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		_ = require('glu/util'),
		config = require('config'),
		Field = require('./Field'),
		Collection = require('glu/collection'),
		log = require('glu/log'),
		Report = require('app/models/Report'),
		Monitor = require('app/models/Monitor'),
		CompoundFilter = require('app/models/CompoundFilter'),
		FieldFilter = require('app/models/FieldFilter'),
		FILTER_TYPES = require('app/config/filterTypes'),
		REPORT_TYPES = require('app/config/reportTypes'),
		Column = require('./Column'),
		appBus = require('glu/appBus'),
		App = require('app/app');

	var COMPOUND_OPERATORS = _.pluck(FILTER_TYPES.compound, 'operator');

	return Model.extend({

		widgets: [],

		initialize: function() {
			var self = this;

			this.initializeReportCollection();
			this.initializeMonitorCollection();
			this.initializeMasterFilter();

			this.listenTo(this, 'report:reload', function() {
				self.initializeReportCollection();
			});

			this.listenTo(this, 'monitor:reload', function() {
				self.initializeMonitorCollection();
			});

			this.listenTo(this, 'segment:reload', function() {
				self.reloadSegments();
			});
		},

		getReportCollectionUrl: function() {
			return config.apiRoot + 'service/reports?domainId=' + this.id;
		},

		getMonitorCollectionUrl: function() {
			return config.apiRoot + 'service/monitors?domainId=' + this.id;
		},

		initializeReportCollection: function() {
			var reportCollection = new Collection([], {
				model: Report
			});

			reportCollection.url = this.getReportCollectionUrl();
			this.set('reportCollection', reportCollection);

			this.reportCollection().fetch().then(function() {
				appBus.trigger('report:reloaded');
			});
		},

		initializeMonitorCollection: function() {
			var monitorCollection = new Collection([], {
				model: Monitor
			});

			monitorCollection.url = this.getMonitorCollectionUrl();
			this.set('monitorCollection', monitorCollection);

			this.monitorCollection().fetch();
		},

		initializeMasterFilter: function() {
			this.listenTo(this, 'sync', this.initMasterFilter);
		},

		parse: function(response) {
			var id = this.id;
			var domainOptions = this.get('domainOptions');

			_.each(response.fields, function(f) {
				_.extend(f, {
					domainId: id
				});

				if (domainOptions && domainOptions.overridings && domainOptions.overridings[f.id]) {
					f.name = domainOptions.overridings[f.id].overrideName;
					f.description = domainOptions.overridings[f.id].overrideDescription;
					f.group = domainOptions.overridings[f.id].overrideGroupName;
					f.order = domainOptions.overridings[f.id].overrideOrder;
					if (domainOptions.overridings[f.id].overrideHidden) {
						f.isHidden = domainOptions.overridings[f.id].overrideHidden;
					}
				}
			});

			var fieldCollection = new Collection(response.fields, {
				model: Field
			});
			fieldCollection.each(function(f) {
				f.set('domainId', response.id);
			});

			response.fieldCollection = fieldCollection;
			return response;
		},

		// process overridinfs and return resultset of the domain fields
		processOverridings: function(domainOptions) {
			var res = [];
			_.each(this.get('fields'), function(f) {
				if (domainOptions && domainOptions.overridings && domainOptions.overridings[f.id]) {
					f.name = domainOptions.overridings[f.id].overrideName;
					f.description = domainOptions.overridings[f.id].overrideDescription;
					f.group = domainOptions.overridings[f.id].overrideGroupName;
					f.order = domainOptions.overridings[f.id].overrideOrder;
					if (domainOptions.overridings[f.id].overrideHidden) {
						f.isHidden = domainOptions.overridings[f.id].overrideHidden;
					}
				}
				res.push(f);
			});
			return res;
		},

		reportCollection: function() {
			return this.get('reportCollection');
		},

		monitorCollection: function() {
			return this.get('monitorCollection');
		},

		spdReport: function() {
			var spdReport = this.reportCollection().findWhere({
				reportType: 'SPD'
			});

			if (spdReport) {
				return spdReport;
			} else {
				return new Report();
			}
		},

		spdFieldIds: function() {
			return this.spdReport().columns().pluck('fieldId');
		},

		url: function() {
			return config.apiRoot + 'service/domains/' + this.id;
		},

		getFieldObjectById: function(id) {
			if (this.get('fieldCollection').length === 0) {
				throw new Error('Trying to look up field when fields have not been fetched yet.');
			}
			return this.get('fieldCollection').get(id);
		},

		getTables: function(isFilterMode) {
			var fields = this.get('fields');

			var domainOptions = this.get('domainOptions');

			if (domainOptions) {
				var fieldsRelationship = domainOptions.fieldsRelationship;
				_.each(fieldsRelationship, function(fr) {
					//find the parent field
					var fld = _.find(fields, function(field) {
						return fr.parentFieldId === field.id;
					});

					fld.showChildFieldsLabel = fr.showChildFieldsLabel;
					fld.childFields = [];

					//move child fields under parent field
					_.each(fr.childFieldIds, function(childFieldId) {
						fld.childFields = fld.childFields.concat(_.filter(fields, function(field) {
							return field.id === childFieldId;
						}));

						//filter child fields from the main filed list
						fields = _.filter(fields, function(field) {
							return field.id !== childFieldId;
						});

						if (fr.group) {
							_.each(fld.childFields, function(field) {
								field.group = fr.group;
							});
							fld.group = fr.group;
						}
					});

					//move child field groups under parent field
					_.each(fr.childGroups, function(childGroup) {
						fld.childFields = fld.childFields.concat(_.filter(fields, function(field) {
							return field.group === childGroup;
						}));

						//filter child field groups from the main filed list
						fields = _.filter(fields, function(field) {
							return field.group !== childGroup;
						});
					});

				});

				// Add virtual columns, exclude in filters
				if (this.get('functions') && isFilterMode !== true) {
					for (var i = 0; i < this.get('functions').length; i++) {
						fields.push({
							description: '',
							funcArguments: this.get('functions')[i].arguments,
							dbFunction: this.get('functions')[i].dbFunction,
							domainId: this.get('id'),
							group: 'Virtual Columns',
							id: this.get('functions')[i].name,
							isHidden: false,
							isMeasure: true,
							name: this.get('functions')[i].displayName,
							type: this.get('functions')[i].type
						});
					}
				}

				fields = _.groupBy(fields, 'group');

				// group fields inside groups
				_.each(_.clone(fields), function(items, group) {
					items = _.filter(items, function(field) {
						return !field.isHidden;
					});
					fields[group] = _.sortBy(items, 'order');
				});
				return fields;
			} else {
				return _.groupBy(fields, 'group');
			}
		},

		getWidgets: function() {
			this.widgets = this.get('domainWidgets');

			if (this.widgets === undefined || this.widgets === null) {
				return null;
			} else {
				// assign some ids for mapping
				for (var i = 0; i < this.widgets.length; i++) {
					this.widgets[i].id = this.id + '+' + i;
				}
				return this.widgets;
			}
		},

		getWidgetById: function(id) {
			if (id < this.widgets.length) {
				return this.widgets[id];
			} else {
				log.warn('Widget id \'' + id + '\' should have been in the range \'0-' + this.widgets.length + '\'');
				return null;
			}
		},

		//public
		//returns DATE or DATETIME fields
		//filtered with 'dashboardMasterfilterFieldIdsFilter' domainOptions (if provided)
		//and sorted by the order they appear in 'dashboardMasterfilterFieldIdsFilter'
		dateFields: function() {
			//try to pull the optional filter to be used (or undefined)
			var masterFilterFieldIds,
				defaultDashboardDateFilter,
				domainOptions = this.get('domainOptions');

			var fields = this.get('fields');

			if (domainOptions) {
				fields = this.processOverridings(domainOptions); // process overridinds first
				masterFilterFieldIds = domainOptions.dashboardMasterfilterFieldIdsFilter;
				defaultDashboardDateFilter = domainOptions.defaultDashboardDateFilter;
			}

			//filter fields by their type
			fields = _.filter(fields, function(field) {
				return field.type === 'DATETIME' || field.type === 'DATE';
			});

			//filter by optional 'filter'
			var res = [];

			// presence of a default dashboard date filter takes precedence over all
			// other filter configurations.
			if (defaultDashboardDateFilter) {
				//find the field from domain with this fieldId
				var defaultFld = _.find(fields, function(field) {
					return defaultDashboardDateFilter === field.id;
				});
				if (defaultFld) {
					defaultFld.domainId = this.id;
					res.push(defaultFld);
				}
			} else if (masterFilterFieldIds) {
				//if filter provided, then it's the master list we iterate over (to keep the desired order of fields)
				_.each(masterFilterFieldIds, function(fieldId) {
					//find the field from domain with this fieldId
					var fld = _.find(fields, function(field) {
						return fieldId === field.id;
					});
					if (fld) {
						res.push(fld);
					}
				});
			} else {
				//otherwise, the order is as in 'fields'
				res = fields;
			}
			return new Collection(res, {
				model: Field
			});
		},

		buildColumn: function(columnData) {
			if (columnData.columnType === 'COUNT') {
				columnData.isMeasure = true;
				columnData.fieldObject = {
					displayName: _.constant('COUNT'),
					isMeasure: function() {
						return true;
					}
				};
			} else if (columnData.columnType === 'FUNCTION') {
				columnData.fieldObject = {
					displayName: function() {
						return columnData.displayName;
					},
					isMeasure: function() {
						return true;
					},
					type: columnData.type
				};
			} else if (columnData.columnType === 'SEGMENT') {
				columnData.fieldObject = {
					displayName: _.constant(columnData.name),
					isMeasure: function() {
						return false;
					}
				};
			} else {
				columnData.fieldObject = this.getFieldObjectById(columnData.fieldId);
			}
			return new Column(columnData);
		},

		buildFilter: function(data) {
			if (COMPOUND_OPERATORS.indexOf(data.operator) === -1) {
				return this.buildFieldFilter(data);
			} else {
				return this.buildCompoundFilter(data);
			}
		},

		buildCompoundFilter: function(data) {
			var self = this;
			var filter;

			filter = new CompoundFilter({
				operator: data.operator,
				filterCollection: new Collection(_.map(data.operands, function(operand) {
					if (operand.operands[0].fieldId) {
						return self.buildFilter(operand);
					} else if (operand.operands[0].function) {
						return self.buildFilter(operand);
					} else if (operand.operands[0].segmentId && operand.operands.length === 2) {
						return self.buildFilter(operand);
					} else {
						return operand;
					}
				}))
			});

			for (var i = 0; i < filter.get('filterCollection').length; i++) {
				filter.get('filterCollection').models[i].set('segmentId', data.operands[i].operands[0].segmentId, {
					silent: true
				});
			}

			return filter;
		},

		buildFieldFilter: function(data) {
			var self = this;
			var fieldId = data.operands[0].fieldId;
			var values = _.chain(data.operands).rest().pluck('val').value();
			var fnCol;

			if (data.operands[0].function) {
				fnCol = _.find(self.get('functions'), function(fn) {
					return fn.name === data.operands[0].function;
				});

				if (fnCol) {
					return new FieldFilter({
						operator: data.operator,
						fieldObject: new Field({
							id: data.operands[0].function,
							name: fnCol.displayName,
							type: fnCol.type
						}),
						funcArguments: data.operands[0].funcArguments,
						columnType: 'FUNCTION',
						values: values,
						arity: values.length
					});
				}
			} else if (data.operands[0].segmentId && data.operands.length === 2) {
				var segment = App.segments.get(data.operands[0].segmentId);

				var column = self.buildColumn({
					segmentId: data.operands[0].segmentId,
					columnType: 'SEGMENT',
					name: segment.get('name')
				});

				var equalsFilter = new FieldFilter({
					operator: 'EQ',
					fieldObject: new Field({
						id: column.get('segmentId'),
						name: column.get('displayName') || column.get('name'),
						type: 'BOOL'
					}),
					columnType: column.get('columnType')
				});

				equalsFilter.setValue(0, data.operands[1].val);

				return equalsFilter;
			} else {
				return new FieldFilter({
					operator: data.operator,
					fieldObject: this.getFieldObjectById(fieldId),
					values: values,
					arity: values.length
				});
			}
		},

		getFiltersFromSegment: function(segmentId) {
			var segmentFilters = App.segments.get(segmentId).get('filters');

			for (var i = 0; i < segmentFilters.operands.length; i++) {
				segmentFilters.operands[i].operands[0].segmentId = segmentId;
			}

			return segmentFilters.operands;
		},

		initMasterFilter: function() {
			var self = this;

			if (this.dateFields().length === 0) {
				throw new Error('Expected domain to have at least one date field.');
			}
			if (!this.has('masterFilter')) {
				var mFieldFilter = this.loadMasterFilter();
				if (mFieldFilter === null) {
					mFieldFilter = this.defaultMasterFilter();
				}
				this.set('masterFilter', mFieldFilter);
				self.listenTo(mFieldFilter, 'change', function() {
					self.saveMasterFilter();
					self.trigger('masterfilterchange');
				});
			}
		},

		//returns a default FieldFilter
		defaultMasterFilter: function() {
			var mFieldFilter = new FieldFilter({
				fieldObject: this.dateFields().at(0),
				operator: 'ROLLINGDATERANGE'
			});

			mFieldFilter.setValue(0, {
				backUnitType: 'DAY',
				backUnitLength: 7,
				durationUnitType: 'DAY',
				durationUnitLength: 7
			});

			return mFieldFilter;
		},

		//private
		//will access User.js trying to restore a master filter associated with this domain.
		//If it can not do so (for whatever reason) it will return 'null'.
		//Otherwise (on success) the correct master filter will be returned.
		loadMasterFilter: function() {
			var key = this.getMasterFilterStorageKey();
			var json = App.user.loadObject(key, null);
			var res = null;
			if (json !== null) {
				res = new FieldFilter({});
				try {
					res.fromJSON(json, this);
				} catch (e) {
					log.warn('Corrupt data for \'' + key + '\' key. Can not do FieldFilter.fromJSON() due to: ' + e.toString());
					res = null;
				}
			}
			return res;
		},

		//private
		//saves current master filter (if it is not 'undefined')
		saveMasterFilter: function() {
			var key = this.getMasterFilterStorageKey();
			var obj = this.getMasterFilter();

			if (obj && obj.isValid()) {
				obj = obj.toJSON();
				App.user.saveObject(key, obj);
			}
		},

		//public
		//returns the key which is going to be used for storing master filter
		getMasterFilterStorageKey: function() {
			return 'domain-' + this.id + '-masterfilter';
		},

		//public
		//simply returns whatever is set as a current master filter
		//returns instance of FieldFilter or 'undefined'
		getMasterFilter: function() {
			return this.get('masterFilter');
		},

		setMasterFilter: function(filter) {
			this.set('masterFilter', filter);
		},

		buildEmptyFilterForFieldId: function(id) {
			return new FieldFilter({
				doFetchConstraintsOnInit: true,
				operator: null,
				fieldObject: this.getFieldObjectById(id),
				values: []
			});
		},

		addReport: function(report) {
			this.reportCollection().add(report);
		},

		replaceReport: function(report) {
			var index;
			this.reportCollection().each(function(r, i) {
				if (r.get('id') === report.get('id')) {
					index = i;
				}
			});

			if (index !== undefined) {
				this.reportCollection().remove(report.get('id'));
				this.reportCollection().add(report, {
					at: index
				});
			}

		},

		getTimespanOptions: function() {
			var output = [],
				categories = this.getTables();

			// Each category
			for (var i in categories) {
				if (categories[i]) {
					// Each field
					_.each(categories[i], function(field) {
						if (field.childFields && field.childFields.length > 0) {
							var count = 0;

							// Each child field
							_.each(field.childFields, function(child) {
								if (!child.isHidden && (child.type === 'DATE' || child.type === 'DATETIME')) {
									output.push({
										description: child.description,
										domainId: child.domainId,
										group: child.group,
										id: child.id,
										isHidden: child.isHidden,
										isMeasure: child.isMeasure,
										name: field.name,
										type: child.type
									});

									count++;
								}
							});

							// Only add the parent if no children have been added
							if (count === 0) {
								if (!field.isHidden && (field.type === 'DATE' || field.type === 'DATETIME')) {
									output.push(field);
								}
							}
						} else {
							if (!field.isHidden && (field.type === 'DATE' || field.type === 'DATETIME')) {
								output.push(field);
							}
						}
					});
				}
			}

			return output;
		},

		getMetrics: function() {
			var reports = this.reportCollection();

			return reports.filter(
				function(report) {
					return report.getReportType() === REPORT_TYPES.METRIC;
				});
		},

		getSegments: function() {
			var self = this;
			var segments = App.segments;

			return segments.filter(
				function(segment) {
					return segment.getDomainId() === self.get('id');
				});
		},

		reloadSegments: function() {
			App.segments.reset();
			App.segments.fetch().then(function() {
				appBus.trigger('segment:reloaded');
			});
		}
	});
});

